import styled from 'styled-components';

export const StyledStarsInput = styled.div`
  margin-top: 8px;
`;
